/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/memberHelpers.ts (PIN Lists)
 🗓️ Created: 2025-01-27
 🧩 Description:
    Helper functions for PIN member management.
────────────────────────────────────────────────────────────────*/

import { PinMember } from '../types';
import { createTempId } from './formDefaults';

/**
 * Map API member to form member
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapApiMember(member: any, index: number): PinMember {
  return {
    id: member.id,
    tempId: member.id ? `db_${member.id}` : createTempId(`temp_${index}`),
    pin: member.pin ?? '',
    description: member.description ?? '',
    enabled: member.enabled ?? true
  };
}

/**
 * Convert form member to API payload member
 */
export function toApiPayloadMember(member: PinMember) {
  return {
    pin: member.pin.trim(),
    description: member.description.trim() || null,
    enabled: member.enabled
  };
}

/**
 * Normalize member for comparison
 */
export function normalizeMemberForCompare(member: PinMember) {
  return {
    pin: member.pin.trim().toLowerCase(),
    description: member.description.trim().toLowerCase(),
    enabled: member.enabled
  };
}

